<div class="complaint-no-login__row" id="complaintNoSubscriptionHeader">
  <div class="complaint-no-login__header col-12">
    <h3 class="complaint-no-login__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('complaint_intro')"
        [innerHTML]="translationService.getTranslation('complaint_intro')"></h3>
  </div>
  <mat-card class="complaint-no-login__card mt-3">
    <mat-card-content class="complaint-no-login__content">
      @if (isDeactivated) {
        <p class="complaint-no-login__deactivated-description col-12 mb-3"
            [innerHTML]="translationService.getTranslation('complaint_deactivated_description')">
        </p>
      }

      @if (!isDeactivated) {
      <p class="complaint-no-login__description col-12 mb-3"
          [innerHTML]="identified? translationService.getTranslation('complaint_description') : translationService.getTranslation('unauthorized_provideInfo_description' )">
      </p>
        <div class="complaint-no-login__row row">
          <div class="complaint-no-login__errors col-12">
            <app-general-errors [errors]="errorsArr"></app-general-errors>
            <div id="complaintNoSubscription" class="complaint-no-login__form">
              @if (useIdentificationForm) {
                <ng-container class="complaint-no-login__identification-form col-12">
                  @if (!identified) {
                    <div class="complaint-no-login__identification-btn col-12">
                      <button mat-flat-button
                              class="complaint-no-login__to-identification-btn btn btn-secondary"
                              (click)="navigateToIdentification()"
                              [innerHTML]="translationService.getTranslation('button_toIdentificationForm')"></button>
                    </div>
                  }
                  @if (isLoadingSub) {
                    <div class="complaint-no-login__spinner" style="text-align: center;">
                      <app-loading-spinner/>
                    </div>
                  }
                </ng-container>
              } @else {
                <app-client-search class="complaint-no-login__client-search"
                                   (validateButtonClick)="loadOrdersForClientno($event)"
                                   [isLoading]="isLoadingSub">
                  @if (clientNoForm.get('clientNo').hasError('message')) {
                    <mat-error>{{ clientNoForm.get('clientNo').getError('message') }}</mat-error>
                  }
                </app-client-search>
              }
              @if (noOrdersFound) {
                <div class="complaint-no-login__no-orders mb-3"
                     [innerHTML]="translationService.getTranslation('complaint_cannot_find_clientno')"></div>
              }
              @if (!isLoadingComp && !isLoadingSub && orders.length > 0; ) {
                @for (sub of orders; track sub; let i = $index) {
                  <mat-card class="complaint-no-login__order-card mt-3" appearance="outlined">
                    <div class="complaint-no-login__order-row row m-3">
                      <div class="complaint-no-login__order-details col-6">
                        <mat-card-title>{{ sub.productDescription }}</mat-card-title>
                        <div class="complaint-no-login__order-info row">
                          <div class="form-group col-12">
                            <div class="row">
                              <div class="col-6"
                                   [innerHTML]="translationService.getTranslation('label_backendid')"></div>
                              <div class="col-6">{{ sub.userBackendId }}</div>
                            </div>
                          </div>
                          <div class="form-group col-12">
                            <div class="row">
                              <div class="col-6" [innerHTML]="translationService.getTranslation('order_id')"></div>
                              @if (sub.backendId <= 0) {
                                <div class="col-6" [innerHTML]="translationService.getTranslation('no_order_id')"></div>
                              }
                              @if (sub.backendId > 0) {
                                <div class="col-6">{{ sub.backendId }}</div>
                              }
                            </div>
                          </div>
                          @if (sub.variantDescription) {
                            <div class="form-group col-12">
                              <div class="row">
                                <div class="col-6"
                                     [innerHTML]="translationService.getTranslation('order_edition')"></div>
                                <div class="col-6">{{ sub.variantDescription }}</div>
                              </div>
                            </div>
                          }
                          <div class="form-group col-12">
                            <div class="row">
                              <div class="col-6" [innerHTML]="translationService.getTranslation('order_product')"></div>
                              <div
                                class="col-6">{{ sub.productDescription ? sub.productDescription : sub.productCode }}
                              </div>
                            </div>
                          </div>
                          <div class="form-group col-12">
                            <div class="row">
                              <div class="col-6"
                                   [innerHTML]="translationService.getTranslation('address_delivery')"></div>
                              <div class="col-6">
                                {{ sub.deliveryAddressList.values().next().value.address.street }}
                                {{ houseNoPipe.transform(sub.deliveryAddressList.values().next().value.address.houseno) }}
                              </div>
                            </div>
                          </div>
                          <div class="form-group col-12">
                            <div class="row">
                              <div class="col-6"></div>
                              <div class="col-6">
                                {{ sub.deliveryAddressList.values().next().value.address.zipcode }}
                                {{ sub.deliveryAddressList.values().next().value.address.city }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="complaint-no-login__order-actions col-6">
                        <mat-card-actions>
                          <button class="complaint-no-login__new-complaint-btn"
                                  mat-raised-button color="primary"
                                  (click)="onNewComplaint(sub)"
                                  [innerHTML]="translationService.getTranslation('button_new_complaint')">
                          </button>
                        </mat-card-actions>
                      </div>
                    </div>
                  </mat-card>
                }
              }
            </div>
          </div>
        </div>
      }
      @if (showContactFormOnComplaintViewWithoutLogin && !isLoadingComp && !isLoadingSub && orders.length == 0) {
        <div class="complaint-no-login__contact">
          <div class="complaint-no-login__contact-row row mt-3 mb-3">
            <div class="complaint-no-login__contact-info col-12 mb-2"
                 [innerHTML]="translationService.getTranslation('complaint_noClientno')">
            </div>
          </div>
          <button ngSkipHydration class="complaint-no-login__contact-btn btn btn-secondary float-end"
                  mat-flat-button
                  (click)="navigateToContact()"
                  [innerHTML]="translationService.getTranslation('complaint_ToContactForm')">
          </button>
        </div>
      }
    </mat-card-content>
  </mat-card>
</div>
